import { HEROKU_ID_KEY, MEMBERSHIP_TYPE } from 'types'
import { convertDollarsToCents } from 'utils'

const apiValuesForMembershipUpgrade = ({ billing, membership }) => {
  const { subtotalWithoutDonations: total_cost } = billing

  const basePayload = {
    upgrading_from: MEMBERSHIP_TYPE.LAKE_CARD,
    upgrading_to: MEMBERSHIP_TYPE.GOLD_CARD,
    membership__c: {
      [HEROKU_ID_KEY]: membership[HEROKU_ID_KEY],
    },
  }

  const { stripeCustomerId, stripePaymentIntentId, stripePaymentMethodId } =
    billing
  return {
    ...basePayload,
    stripe_customer_id: stripeCustomerId,
    stripe_payment_intent_id: stripePaymentIntentId,
    stripe_payment_method_id: stripePaymentMethodId,
    total_cost: convertDollarsToCents(total_cost),
  }
}

export default apiValuesForMembershipUpgrade
